import React from 'react';
import { FeaturePageLayout } from '../components/FeaturePageLayout';
import { Megaphone, PenTool, Share2, TrendingUp, Mail, Search } from 'lucide-react';
/*
  SEO SPECIFICATION:
  Title: Self-Marketing AI — Content, Ads, Social & SEO Running Automatically
  Meta Desc: MISTR writes your content, manages your ads, posts to social, and monitors SEO — all in your brand voice, automatically. Marketing while you sleep.
  Primary KW: AI marketing automation for small business
*/
export function SelfMarketing() {
  return <FeaturePageLayout seoTitle="Self-Marketing — Autopilot Growth | MindStream.ing" seoDesc="MISTR writes your content, manages your ads, posts to social, and monitors SEO — all in your brand voice, automatically. Marketing while you sleep." heroEyebrow="SELF-MARKETING" heroTitle={<>
          Marketing That <span className="text-gradient" data-id="element-2721" data-mp="2awiyw5svl4i7">Markets Itself.</span>
        </>} heroDesc="Content written, ads optimized, social posted, SEO handled — MR manages the whole marketing engine." heroImage="https://cdn.magicpatterns.com/uploads/dWXrt9xNFh6bNpGwsjysP6/ChatGPT_Image_Mar_20,_2026,_02_15_39_PM.png" problem={{
    subtitle: 'Marketing requires constant attention. Content calendars, ad optimization, social posting — it never stops.',
    cards: [{
      icon: <Megaphone size={32} data-id="element-2722" data-mp="2elkltb4zbj57" />,
      title: 'Inconsistent Output',
      desc: 'You post every day for a week, then get busy and go silent for a month. Your audience forgets you.'
    }, {
      icon: <TrendingUp size={32} data-id="element-2723" data-mp="25kmeojz8uvie" />,
      title: 'Wasted Ad Spend',
      desc: 'You set up a campaign, forget to check it, and waste thousands on underperforming keywords.'
    }]
  }} howItWorks={{
    title: 'How It Works',
    steps: [{
      title: 'Set Strategy',
      desc: 'Tell MR your brand voice and goals once.'
    }, {
      title: 'Auto-Create',
      desc: 'Content is created in your voice automatically on schedule.'
    }, {
      title: 'Optimize',
      desc: 'Ads are optimized, social is posted, and SEO is monitored 24/7.'
    }]
  }} features={{
    cards: [{
      icon: <PenTool size={24} data-id="element-2724" data-mp="2i3qigqqqi1x9" />,
      title: 'Blog Content Agent',
      desc: 'Researches, writes, and publishes SEO-optimized articles in your voice.'
    }, {
      icon: <Share2 size={24} data-id="element-2725" data-mp="285kd1z5pydnn" />,
      title: 'Social Posting',
      desc: 'Creates and schedules engaging posts across LinkedIn, Twitter, and Facebook.'
    }, {
      icon: <TrendingUp size={24} data-id="element-2726" data-mp="6e7b9iz1slvt" />,
      title: 'PPC Optimization',
      desc: 'Monitors ad spend, adjusts bids, and pauses losing campaigns automatically.'
    }, {
      icon: <Mail size={24} data-id="element-2727" data-mp="1kb0jj37feb60" />,
      title: 'Email Sequences',
      desc: 'Writes and triggers personalized nurture campaigns for new leads.'
    }, {
      icon: <Search size={24} data-id="element-2728" data-mp="1u0k3ydased2z" />,
      title: 'SEO Monitoring',
      desc: 'Tracks rankings and suggests content updates to maintain your position.'
    }]
  }} demoTitle="Watch It Market Live" demoDesc="See how a simple conversation instantly creates a full marketing campaign." demoCallout="David just told MR about a new feature. Refresh. The campaign is live." pricingCallout="All included in MR Pro ($997/mo)" data-id="element-2720" data-mp="2ttsl1upl4w35" />;
}